import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

function PlanCheckInCard({ dayKey, checkInDays }) {
  const { t } = useTranslation("athlete-portal");
  if (!checkInDays || !checkInDays.includes(dayKey)) return null;
  return (
    <div className="plan-card plan-card--check-in">
      <div className="plan-card__header">
        <SvgIcon
          src="/img/new-icons/clipboard-check-solid.svg"
          useCurrentColor={true}
        />
        {t("calendar.cards.checkIn.title")}
      </div>
    </div>
  );
}

export default PlanCheckInCard;
